import React, {RefObject} from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize} from "@pg-design/helpers-css";

import {useReelPlayerProgress} from "../../../hooks/use_reel_player_progress";

interface IProps {
    videoRef?: RefObject<HTMLVideoElement | null>;
}

export const ReelDetailsProgressBar = (props: IProps) => {
    const progressBarWidth = useReelPlayerProgress({
        videoRef: props.videoRef,
        defaultProgress: 0
    });

    return (
        <div css={wrapperStyle}>
            <div css={progressBarStyle} style={{width: `${progressBarWidth}%`}} />
        </div>
    );
};

const wrapperStyle = (theme: Theme) => css`
    position: relative;
    height: ${calculateRemSize(1)};
    width: 100%;
    flex: 1 1 100%;
    ${borderRadius(0.5)};
    overflow: hidden;
    background-color: ${theme.colors.gray[600]};
`;

const progressBarStyle = css`
    background-color: #fff;
    ${borderRadius(0.5)};
    height: ${calculateRemSize(1)};
    transition: width 0.3s linear;
`;
import React, {RefObject} from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize} from "@pg-design/helpers-css";

import {useReelPlayerProgress} from "../../../hooks/use_reel_player_progress";

interface IProps {
    videoRef?: RefObject<HTMLVideoElement | null>;
}

export const ReelDetailsProgressBar = (props: IProps) => {
    const progressBarWidth = useReelPlayerProgress({
        videoRef: props.videoRef,
        defaultProgress: 0
    });

    return (
        <div css={wrapperStyle}>
            <div css={progressBarStyle} style={{width: `${progressBarWidth}%`}} />
        </div>
    );
};

const wrapperStyle = (theme: Theme) => css`
    position: relative;
    height: ${calculateRemSize(1)};
    width: 100%;
    flex: 1 1 100%;
    ${borderRadius(0.5)};
    overflow: hidden;
    background-color: ${theme.colors.gray[600]};
`;

const progressBarStyle = css`
    background-color: #fff;
    ${borderRadius(0.5)};
    height: ${calculateRemSize(1)};
    transition: width 0.3s linear;
`;
